// @vendors
const Immutable = require('immutable');

const actionTypes = require('../raConstants/actionTypes');

// @constants
const {
    SUITABILITY_TEST_STEP_3,
    QUESTIONS_FOR_STEP,
} = require('../raConstants/index');

// @core
const { getStore } = require('core/storeHelper');

const initialState = Immutable.fromJS({
    persistedWizards: [],
    totalAnswers: 0,
});

const RAWizard = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_WIZARD_INITIALIZE: {
            return state.merge({
                persistedWizards: {
                    [action.payload.identifier]: {
                        currentStepIndex: 0,
                        lastStepIndex: 0,
                        currentStep: 0,
                        currentCategory: 0,
                        categories: action.payload.categories,
                        showModal: false,
                    },
                },
            });
        }
        case actionTypes.RA_WIZARD_TOGGLE_CATEGORY_EXPANDANDABILITY_VALUE: {
            const { identifier, categoryIndex } = action.payload;
            return state.updateIn(
                ['persistedWizards', identifier, 'categories', categoryIndex],
                category => {
                    return category.set(
                        'isExpandable',
                        !category.get('isExpandable'),
                    );
                },
            );
        }
        case actionTypes.RA_WIZARD_TOGGLE_CATEGORY_EXPANDED_VALUE: {
            const { identifier, categoryIndex } = action.payload;
            return state.updateIn(
                ['persistedWizards', identifier, 'categories', categoryIndex],
                category => {
                    return category.set(
                        'isExpanded',
                        !category.get('isExpanded'),
                    );
                },
            );
        }
        case actionTypes.RA_WIZARD_CHANGE_STEP_COMPLETED_VALUE: {
            const { identifier, categoryIndex, stepIndex } = action.payload;
            return state.updateIn(
                [
                    'persistedWizards',
                    identifier,
                    'categories',
                    categoryIndex,
                    'steps',
                    stepIndex,
                ],
                step => {
                    return step.set('isCompleted', !step.get('isCompleted'));
                },
            );
        }
        case actionTypes.RA_WIZARD_MARK_COMPLETED_AND_CHANGE_STEP: {
            const { identifier, current, next } = action.payload;
            const nextStepIdentifier = state
                .getIn([
                    'persistedWizards',
                    identifier,
                    'categories',
                    next.category,
                    'steps',
                    next.step,
                ])
                .get('identifier');

            const nextStepIndex = state
                .getIn(['persistedWizards', identifier, 'categories'])
                .flatMap(category => category.get('steps'))
                .findKey(x => x.get('identifier') === nextStepIdentifier);
            const lastStepIndex = Math.max(
                state.getIn(['persistedWizards', identifier, 'lastStepIndex']),
                nextStepIndex,
            );

            return state
                .updateIn(
                    ['persistedWizards', identifier, 'currentStepIndex'],
                    () => nextStepIndex,
                )
                .updateIn(
                    ['persistedWizards', identifier, 'lastStepIndex'],
                    () => lastStepIndex,
                )
                .updateIn(
                    ['persistedWizards', identifier, 'currentStep'],
                    () => next.step,
                )
                .updateIn(
                    ['persistedWizards', identifier, 'currentCategory'],
                    () => next.category,
                )
                .updateIn(
                    [
                        'persistedWizards',
                        identifier,
                        'categories',
                        next.category,
                    ],
                    categories => categories.set('isExpanded', true),
                )
                .updateIn(
                    ['persistedWizards', identifier, 'categories'],
                    categories =>
                        categories.map((category, key) =>
                            category.set('isActive', key === next.category),
                        ),
                )
                .updateIn(
                    [
                        'persistedWizards',
                        identifier,
                        'categories',
                        current.category,
                        'steps',
                        current.step,
                    ],
                    step =>
                        step
                            .set('isActive', false)
                            .set('isCompleted', true)
                            .set('canContinue', true),
                )
                .updateIn(
                    [
                        'persistedWizards',
                        identifier,
                        'categories',
                        next.category,
                        'steps',
                        next.step,
                    ],
                    step => step.set('isActive', true).set('isAvailable', true),
                );
        }

        case actionTypes.RA_WIZARD_CHANGE_STEP: {
            const { identifier, current, next } = action.payload;
            const nextStepIdentifier = state
                .getIn([
                    'persistedWizards',
                    identifier,
                    'categories',
                    next.category,
                    'steps',
                    next.step,
                ])
                .get('identifier');

            const nextStepIndex = state
                .getIn(['persistedWizards', identifier, 'categories'])
                .flatMap(category => category.get('steps'))
                .findKey(x => x.get('identifier') === nextStepIdentifier);
            const lastStepIndex = Math.max(
                state.getIn(['persistedWizards', identifier, 'lastStepIndex']),
                nextStepIndex,
            );

            return state
                .updateIn(
                    ['persistedWizards', identifier, 'currentStepIndex'],
                    () => nextStepIndex,
                )
                .updateIn(
                    ['persistedWizards', identifier, 'lastStepIndex'],
                    () => lastStepIndex,
                )
                .updateIn(
                    ['persistedWizards', identifier, 'currentStep'],
                    () => next.step,
                )
                .updateIn(
                    ['persistedWizards', identifier, 'currentCategory'],
                    () => next.category,
                )
                .updateIn(
                    [
                        'persistedWizards',
                        identifier,
                        'categories',
                        next.category,
                    ],
                    categories => categories.set('isExpanded', true),
                )
                .updateIn(
                    ['persistedWizards', identifier, 'categories'],
                    categories =>
                        categories.map((category, key) =>
                            category.set('isActive', key === next.category),
                        ),
                )
                .updateIn(
                    [
                        'persistedWizards',
                        identifier,
                        'categories',
                        current.category,
                        'steps',
                        current.step,
                    ],
                    step => step.set('isActive', false),
                )
                .updateIn(
                    [
                        'persistedWizards',
                        identifier,
                        'categories',
                        next.category,
                        'steps',
                        next.step,
                    ],
                    step => step.set('isActive', true).set('isAvailable', true),
                );
        }

        case actionTypes.RA_WIZARD_STEP_UPDATED: {
            const {
                value,
                category,
                step,
                wizardIdentifier,
                isCompleted,
                isTestV6,
            } = action.payload;
            let canContinue = value;
            const immSuitabilityTest = getStore().getState().raSuitabilityTest;
            if (category === SUITABILITY_TEST_STEP_3 && !isTestV6) {
                let totalQuestionsWithAnswers = 0;
                QUESTIONS_FOR_STEP[SUITABILITY_TEST_STEP_3].forEach(
                    questionId => {
                        if (
                            immSuitabilityTest.getIn([
                                'answers',
                                questionId,
                            ]) !== ''
                        ) {
                            totalQuestionsWithAnswers++;
                        }
                    },
                );
                canContinue =
                    totalQuestionsWithAnswers ===
                    QUESTIONS_FOR_STEP[SUITABILITY_TEST_STEP_3].length;
            } else if (category === SUITABILITY_TEST_STEP_3 && isTestV6) {
                canContinue = true;
            }
            const currentWizardState = state.getIn([
                'persistedWizards',
                wizardIdentifier,
            ]);
            let categoryIndex = currentWizardState.get('currentCategory');
            let stepIndex = currentWizardState.get('currentStep');
            if (category != null && step != null) {
                categoryIndex = category;
                stepIndex = step;
            }

            return state.mergeDeepIn(
                [
                    'persistedWizards',
                    wizardIdentifier,
                    'categories',
                    categoryIndex,
                    'steps',
                    stepIndex,
                ],
                {
                    isCompleted: isCompleted,
                    canContinue,
                },
            );
        }
        case actionTypes.RA_WIZARD_SHOW_MODAL: {
            const { identifier, value } = action.payload;
            return state.mergeDeepIn(['persistedWizards', identifier], {
                showModal: value,
            });
        }
        case actionTypes.RA_WIZARD_SHOW_FIRST_ANSWER_MODAL: {
            const { identifier, value } = action.payload;
            return state.mergeDeepIn(['persistedWizards', identifier], {
                showFirstAnswerModal: value,
            });
        }
        case actionTypes.RA_WIZARD_SHOULD_DISPLAY_MODAL: {
            const { value, identifier, category, step } = action.payload;
            const currentWizardState = state.getIn([
                'persistedWizards',
                identifier,
            ]);

            let categoryIndex = currentWizardState.get('currentCategory');
            let stepIndex = currentWizardState.get('currentStep');
            if (category != null && step != null) {
                categoryIndex = category;
                stepIndex = step;
            }

            return state.mergeDeepIn(
                [
                    'persistedWizards',
                    identifier,
                    'categories',
                    categoryIndex,
                    'steps',
                    stepIndex,
                ],
                {
                    shouldDisplayModal: value,
                },
            );
        }
        case actionTypes.RA_WIZARD_SET_TOTAL_ANSWERS:
            return state.merge({
                totalAnswers: action.payload,
            });
        case actionTypes.RA_WIZARD_RESET:
            return initialState;
        default:
            return state;
    }
};

module.exports = RAWizard;
